import { toSiteCorePath, withBasePath } from '@src/common/path-convert';
import CategorySwiper from '@components/category-swiper/CategorySwiper';
import { GetServerSideProps, GetServerSidePropsResult } from 'next';
import { sitecoreClient, withOps } from '@src/utils/graphql-request';
import { AppLanguage } from '@src/common/app-language';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {
    ContentBlockFragment,
    SlideFragment,
    BadgesIconQueryResult,
    PageGenericSliderQueryResult,
    PageKolLeaderboard,
    MetaFragment,
    AllupBetlineFragment,
    CategoriesFragment,
} from '@graphqlTypes/sitecore';
import {
    findCategoryTitleByKey,
    getFullImgPath,
    isTimeFrame,
    objFilter,
    withSitPath,
} from '@src/utils/util';
import { useTranslation } from 'next-i18next';
import { format } from 'date-fns';
import { Pagination } from 'swiper';
import {
    isContentBlockExpired,
    isContentBlockPublished,
    predicateContentBlock,
} from '@src/common/filter';
import styles from './detail.module.scss';
import { ErrorPageType } from '@src/common/enums';
import { CSSProperties, memo, Suspense, useEffect, useMemo, useRef, useState } from 'react';
import { useLinkHandlers } from '@src/hooks/use-link-handlers';
import cn from 'classnames';
import DeatilRemark from '@components/deatil-remark/DeatilRemark';
import { AppArticlePageProp, ComponentDataListFragment, ErrorPageProp } from '@src/common/types';
import DynamicComponent from '@components/dynamic-component/DynamicComponent';
import OddsChanges from '@components/odds-changes/OddsChanges';
import OddsStore from '@mobx/stores/kolBetpick/kolOddsLastDate';
import AllBettingStrategyBTN from '@components/all-betting-strategy-BTN/AllBettingStrategyBTN';
import useWindowSize from '@src/utils/useWindowSize';
import Open3in1App from '@components/open-3in1-app/Open3in1App';
import isSharePageStore from '@mobx/stores/isShare-store';
import bettingStrategyStore from '@mobx/stores/bettingStrategy-store';
import { reaction } from 'mobx';
import SpinLoading from 'antd-mobile/es/components/spin-loading';
import Head from 'next/head';
import { mediaDomain } from '@src/middleware';

interface Props {
    currentPath: string;
    comCurrentPath: string;
    componentDataList: ComponentDataListFragment;
    contentBlockData: {
        parent?: { name: string; useSimplifiedChinese?: { boolValue?: boolean } };
    } & ContentBlockFragment;
    pageType: string;
    badgesIconData: BadgesIconQueryResult;
    language: string;
    metaItem: { meat: MetaFragment };
    mediaDomain: string;
    AllUpData: AllupBetlineFragment[];
    categoryData: CategoriesFragment[];
}
interface KolRankImg {
    rank?: { value: number };
    imgLink?: { value: string };
}

interface ConditionalStyle {
    marginBottom: string;
    height?: string;
    overflow?: string;
}

const Detail = (props: Props) => {
    // console.log('detail----', props);
    const detailRef = useRef<HTMLDivElement | null>(null);
    const { t, i18n } = useTranslation(['common', 'home', 'kol', 'share']);
    const { width, height } = useWindowSize();
    /** 是否显示All Betting Strategy 按钮 */
    const [isShowBettingBtn, setIsShowBettingBtn] = useState(
        bettingStrategyStore.GetbettingBTNList()
    );
    const lang = i18n.language;

    // console.log('isShowBettingBtn===', isShowBettingBtn);
    const isEn = lang.toLocaleLowerCase() === 'en-us';
    const SPad = width >= 630 && width <= 790;
    const width790 = width > 790 && width < 1024;
    const width1024 = width >= 1024;
    const refHeight = detailRef?.current?.offsetHeight ?? 0;
    const isWidth1440 = width >= 1440;
    // console.log('refHeight====', refHeight);
    const {
        comCurrentPath,
        componentDataList,
        contentBlockData,
        language,
        currentPath,
        metaItem,
        mediaDomain,
        AllUpData,
        categoryData,
    } = props;

    const contentBlock = props.contentBlockData;

    const {
        category,
        pageTitle,
        startDatetime,
        iconDisplay,
        iconDisplayEndDate,
        iconDisplayStartDate,
        isIconDisplay,
        shareIcon,
        detailTitleBlock,
        updateDatetime,
        heroImage,
        description,
        parent,
    } = contentBlockData;

    const isZHCN = parent?.useSimplifiedChinese?.boolValue ?? false;
    const contentCategoryTitle =
        (category?.categories &&
            category.categories.length > 0 &&
            objFilter(category?.categories)[0]?.categoryTitle?.value) ||
        '';
    const contentCategoryName =
        (category?.categories &&
            category.categories.length > 0 &&
            objFilter(category?.categories)[0]?.name) ||
        '';
    const contentCategoryText = isZHCN
        ? findCategoryTitleByKey(contentCategoryName, categoryData)
        : contentCategoryTitle;

    const [showOddsChanges, setShowOddsChanges] = useState(false);
    const [showOddsChangesCom, setshowOddsChangesCom] = useState(false);
    const [getKOLRankingImg, setGetKOLRankingImg] = useState<KolRankImg[]>([]);
    const [pBNum, setPBNum] = useState(0);
    const [onceHalf, setOnceHalf] = useState(true);

    // const [refHeight, setRefHeight] = useState(0);
    // const [halfH, setHalfH] = useState(0);
    const [conditionalStyle, setConditionalStyle] = useState<CSSProperties | any>();

    useLinkHandlers(detailRef.current);

    const isKolLeaderboard = comCurrentPath.includes('kol-leaderboard');
    /** 需要截取50%的页面 */
    const isDisplayContent =
        (currentPath === 'kol-section' && !isKolLeaderboard) || currentPath === 'hero-banner';

    const isKOL =
        !!componentDataList.find((i: any) => i.content?.template?.name === 'PageKolLeaderboard') ||
        false;

    const isSlider =
        !!componentDataList.find(
            (i: any) =>
                i.content?.template?.name === 'PageGenericSlider' &&
                i.content?.sliderEnabled?.boolValue
        ) || false;

    const showLBNotification =
        !!componentDataList.find(
            (i: any) =>
                i.content?.template?.name === 'PageKolLeaderboard' &&
                i.content?.notificationEnable?.boolValue
        ) || false;
    const lbContent: PageKolLeaderboard | any = componentDataList.find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (i: any) => i.content?.template?.name === 'PageKolLeaderboard'
    );
    const showOddsTips =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !!componentDataList.find((i: any) => i.content?.template?.name === 'PageBetpickLink') ||
        false;

    const slidesData = () => {
        const List: SlideFragment[] = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sliderObj: PageGenericSliderQueryResult | any = componentDataList.find(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (i: any) => i.content?.template?.name === 'PageGenericSlider'
        );
        sliderObj &&
            sliderObj.content?.sliderEnabled?.boolValue &&
            sliderObj.content?.slides?.forEach((v: SlideFragment) => {
                v.slideEnabled?.boolValue && List.push(v);
            });
        return List;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const imgUrl = (getUrl: string) => {
        if (getUrl.startsWith('//')) {
            return `https:${getUrl}`;
        } else if (getUrl.startsWith('/')) {
            return `${mediaDomain}${getUrl}`;
        } else {
            return getUrl;
        }
    };
    // get ranking image
    const kolRankingImg = () => {
        const rankingList = new Set(['1', '2', '3']);
        const List: KolRankImg[] = [];
        const kolProfile: PageKolLeaderboard | any = componentDataList.find(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (i: any) => i.content?.template?.name === 'PageKolLeaderboard'
        );
        kolProfile &&
            kolProfile.content?.children &&
            kolProfile.content?.children.forEach((v: any) => {
                const kolProfile = v.kolProfileLink?.targetItem;
                if (
                    kolProfile &&
                    kolProfile.rank &&
                    kolProfile.kolName &&
                    rankingList.has(kolProfile.rank?.value)
                ) {
                    const imgName =
                        'KolProfile/Ranking/' +
                        (language === AppLanguage.en_us ? 'English/' : 'Chinese/') +
                        kolProfile.name +
                        '_' +
                        kolProfile.rank.value;
                    const kolObj: KolRankImg = {
                        rank: { value: kolProfile.rank.value },
                        imgLink: { value: getFullImgPath(imgName) },
                    };
                    List.push(kolObj);
                }
            });
        const tempList = List?.filter(
            (item): item is Required<KolRankImg> => !!item.rank?.value && !!item.imgLink?.value
        )?.sort((a, b) => {
            // 定义优先级顺序：2 > 1 > 3 > 其他
            const priority: Record<number, number> = {
                2: 0,
                1: 1,
                3: 2,
            };
            const aRank = a.rank.value;
            const bRank = b.rank.value;

            return (priority[aRank] ?? 3) - (priority[bRank] ?? 3);
        });
        return tempList;
    };

    /** 头部slide */
    const getBgImg: SlideFragment[] = slidesData();

    useEffect(() => {
        if (typeof window !== undefined) {
            setGetKOLRankingImg(kolRankingImg());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * 数据处理
     * OddsChanges显示规则
     * displayOdds: true
     * displayManualInput: false
     *
     *     const showOddsChanges = displayOdds?.boolValue && !displayManualInput?.boolValue;
     */
    useEffect(() => {
        const filterList = componentDataList.filter(
            (i: any) => i.content?.template?.name === 'PageBetpickLink'
        );
        if (filterList.length > 0) {
            const atLeastOneSatisfiesCondition = (data: any[]): boolean => {
                return data.some(
                    (item) =>
                        item?.content?.betpickLink?.targetItem?.race?.meeting?.displayOdds
                            ?.boolValue &&
                        !item?.content?.betpickLink?.targetItem?.race?.meeting?.displayManualInput
                            ?.boolValue
                );
            };
            const atLeastOneTrue = atLeastOneSatisfiesCondition(filterList);
            setShowOddsChanges(atLeastOneTrue);
        } else {
            setShowOddsChanges(false);
        }
    }, [componentDataList]);

    useEffect(() => {
        isSharePageStore.setIsSharePage(true);
        OddsStore.addLastUpdateDate([]);
        bettingStrategyStore.setResetBetpickTitleList();
    }, []);

    useEffect(() => {
        const dispose = reaction(
            () => bettingStrategyStore.GetbettingBTNList(),
            (showButton) => {
                setIsShowBettingBtn(showButton);
            }
        );

        return () => {
            dispose();
            bettingStrategyStore.setResetList();
            bettingStrategyStore.setResetBetpickTitleList();
        };
    }, []);

    /** 跟换白色背景 */
    useEffect(() => {
        document.body.style.backgroundColor = '#ffffff';
        document.body.style.height = '100%';
    }, []);

    useEffect(() => {
        if (refHeight > 0 && onceHalf) {
            console.log('refHeight++++++', refHeight);
            const timeOutId = setTimeout(() => {
                const halfH = refHeight / 2;
                const curMinHeight = height - pBNum;
                const commonStyle = {
                    marginBottom: `${pBNum}px`,
                };

                let conditionalStyle: ConditionalStyle = commonStyle;

                if (isDisplayContent) {
                    conditionalStyle = {
                        ...commonStyle,
                        height: `${halfH > curMinHeight ? halfH + pBNum : curMinHeight}px`,
                        overflow: 'hidden',
                    };
                }

                setConditionalStyle(conditionalStyle);
                setOnceHalf(false);
            }, 800);

            return () => clearTimeout(timeOutId);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refHeight, pBNum, isDisplayContent]);

    const { titleHtml, imgHtml, descriptionHtml } = useMemo(() => {
        let titleHtml = '';
        let imgHtml = '';
        let descriptionHtml = '';

        titleHtml = pageTitle?.value
            ? `${pageTitle?.value || ''} - ${metaItem.meat?.metaTitleSuffix?.value} `
            : `${metaItem.meat?.metaTitleSuffix?.value}`;
        imgHtml = imgUrl(heroImage?.src || '');
        descriptionHtml = description?.value || '';
        return { titleHtml, imgHtml, descriptionHtml };
    }, [
        description?.value,
        heroImage?.src,
        imgUrl,
        metaItem.meat?.metaTitleSuffix?.value,
        pageTitle?.value,
    ]);

    return (
        <>
            <Head>
                <title>{titleHtml}</title>
                <meta property='og:title' content={titleHtml} key='title' />
                <meta property='og:image' content={imgHtml} />
                <meta property='og:description' content={descriptionHtml} />
            </Head>
            <div
                ref={detailRef}
                className={cn(`detailPage relative ${styles.details} pointer-events-none`)}
                style={{
                    background: '#ffffff',
                    width: isWidth1440 ? '1440px' : '100%',
                    maxWidth: '1440px',
                    margin: '0 auto',
                    ...conditionalStyle,
                }}
            >
                <div
                    className={cn(
                        isKOL
                            ? 'bg-[#0084AD] min-h-[100vh] pb-4'
                            : ' md:pr-[24px] md:pt-[24px] md:pl-[24px] bg-[#ffffff]',
                        getBgImg.length > 0 && !isKOL && 'md:flex md:flex-row '
                    )}
                    style={
                        isKOL
                            ? {
                                  backgroundImage: `url(${withBasePath(
                                      `/images/kol/${
                                          SPad || width790 || width1024 ? 'kolBG630' : 'kolBG375'
                                      }.svg`
                                  )})`,
                                  backgroundSize: width1024 ? '100%' : 'contain',
                                  backgroundRepeat: 'no-repeat',
                              }
                            : {}
                    }
                >
                    {isKOL && showLBNotification && (
                        <div className='px-4 pt-4 flex justify-center items-center'>
                            <div
                                className={cn(
                                    'bg-white rounded-[8px] px-2 py-1 overflow-hidden flex-row flex w-full'
                                )}
                                style={{
                                    boxShadow:
                                        '0px 5px 5px -1px rgb(0 0 0 / 0.2), 0 4px 6px -4px rgb(0 0 0 / 0.2)',
                                }}
                            >
                                <img
                                    className='w-24px mr-1 mt-1 self-start'
                                    src={withBasePath('/images/kol/notification.svg')}
                                    alt=''
                                    loading='lazy'
                                />
                                <div className='px-2 py-1'>
                                    {lbContent.content?.notificationText?.value ?? ''}
                                </div>
                            </div>
                        </div>
                    )}
                    {isKOL ? (
                        isSlider ? (
                            <div
                                className='mt-[15px] h-[239px] w-full bg-contain bg-center bg-no-repeat relative'
                                style={{
                                    backgroundImage: `url(
                        ${withSitPath(getBgImg[0]?.slideImage?.src || '')}
                    )`,
                                }}
                            >
                                {shareIcon?.boolValue && (
                                    <img
                                        className='w-[24px] h-[24px] absolute top-[15px] right-[15px] z-10'
                                        src={withBasePath('/images/share_white.svg')}
                                        alt=''
                                        loading='lazy'
                                    />
                                )}
                            </div>
                        ) : (
                            <div className='pt-[15px] w-full'>
                                <div className='flex'>
                                    <img
                                        className={cn(
                                            'z-10 pl-[15px] md:pl-6 h-[38px]',
                                            isEn ? 'w-[94px]' : 'w-[78px]'
                                        )}
                                        src={withBasePath(
                                            `/images/kol/i-TippingOne${isEn ? '' : 'CH'}.png`
                                        )}
                                        alt=''
                                        loading='lazy'
                                    />
                                    {shareIcon?.boolValue && !isSlider && (
                                        <div className='flex h-[24px] justify-end flex-1 pr-[15px] md:pr-6'>
                                            <img
                                                className='w-[24px] h-[24px] z-10'
                                                src={withBasePath('/images/kol/share-blue.svg')}
                                                alt=''
                                                loading='lazy'
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className='flex w-full items-end justify-center'>
                                    {getKOLRankingImg &&
                                        getKOLRankingImg?.map((r, index) => {
                                            const sizeClasses = cn({
                                                'w-[99.37px] aspect-[1/1.61] md:w-[129.18px] lg:w-[129.18px] sd:w-[99.37px] ss:w-[89.43px]':
                                                    index === 0,
                                                'w-[118px] aspect-[1/1.61] md:w-[153.4px] lg:w-[153.4px] sd:w-[118px] ss:w-[106.2px] mx-[16px]':
                                                    index === 1,
                                                'w-[93.16px] aspect-[1/1.61] md:w-[121.11px] lg:w-[121.11px] sd:w-[93.16px] ss:w-[83.84px]':
                                                    index === 2,
                                            });

                                            const renderIcons = () => {
                                                switch (index) {
                                                    case 0:
                                                        return (
                                                            <img
                                                                src={withBasePath(
                                                                    '/images/kol/i-em-smileyFace.svg'
                                                                )}
                                                                alt=''
                                                                loading='lazy'
                                                                className='absolute z-10 w-[36px] lg:w-[46.8px] sd:w-[36]px ss:w-[32.4px] top-[38%] sd:-left-[15%] ss:-left-[10%]'
                                                            />
                                                        );
                                                    case 1:
                                                        return (
                                                            <>
                                                                <img
                                                                    src={withBasePath(
                                                                        '/images/kol/i-em-crown.svg'
                                                                    )}
                                                                    alt=''
                                                                    loading='lazy'
                                                                    className={cn(
                                                                        'absolute z-10 w-[40px] lg:w-[52px] top-[-10%] right-[1%]',
                                                                        SPad && 'top-[-7%]',
                                                                        (width790 || width1024) &&
                                                                            'top-[-8%]'
                                                                    )}
                                                                />
                                                                <img
                                                                    src={withBasePath(
                                                                        '/images/kol/i-eml-love.svg'
                                                                    )}
                                                                    alt=''
                                                                    loading='lazy'
                                                                    className='absolute z-10 w-[20px] lg:w-[26px] top-[50%] left-[16%]'
                                                                />
                                                                <img
                                                                    src={withBasePath(
                                                                        '/images/kol/i-emr-love.svg'
                                                                    )}
                                                                    alt=''
                                                                    loading='lazy'
                                                                    className='absolute z-10 w-[36.41px] lg:w-[47.33px] top-[65%] right-[4%]'
                                                                />
                                                            </>
                                                        );
                                                    case 2:
                                                        return (
                                                            <img
                                                                src={withBasePath(
                                                                    '/images/kol/i-em-horse.svg'
                                                                )}
                                                                alt=''
                                                                loading='lazy'
                                                                className='absolute z-10 w-[26px] lg:w-[33.8px] top-[49%] left-[4%]'
                                                            />
                                                        );
                                                    default:
                                                        return null;
                                                }
                                            };

                                            return (
                                                <div
                                                    key={r.rank?.value ?? index}
                                                    className='relative'
                                                >
                                                    <img
                                                        src={r.imgLink?.value || ''}
                                                        alt={`Rank ${r.rank?.value}`}
                                                        loading='lazy'
                                                        className={sizeClasses}
                                                    />
                                                    {renderIcons()}
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )
                    ) : (
                        <CategorySwiper
                            options={{
                                modules: [Pagination],
                                pagination: {
                                    enabled: true,
                                    type: 'bullets',
                                },
                                slidesPerView: 1,
                                autoplay: true,
                                loop: true,
                            }}
                            swiperStylesName={'detail-swiper'}
                            swiperClassName='w-full md:w-[298px] lg:w-[401px]'
                        >
                            {getBgImg &&
                                getBgImg.map((r: SlideFragment, index: number) => (
                                    <div key={index} className='relative'>
                                        {isTimeFrame(
                                            (isIconDisplay && isIconDisplay.boolValue) || false,
                                            iconDisplayStartDate?.dateValue || 0,
                                            iconDisplayEndDate?.dateValue || 0
                                        ) && (
                                            <img
                                                src={withSitPath(
                                                    iconDisplay?.targetItem?.iconImage?.src
                                                )}
                                                alt=''
                                                loading='lazy'
                                                className='h-[20px] absolute top-[12px] left-[12px]'
                                            ></img>
                                        )}
                                        <img
                                            className='md:rounded-[4px] lg:rounded-[4px] w-[100%]'
                                            loading='lazy'
                                            src={withSitPath(r.slideImage?.src)}
                                            alt=''
                                        />
                                    </div>
                                ))}
                        </CategorySwiper>
                    )}

                    <div
                        className={`z-10 sticky md:mt-0  ${
                            isKOL ? '' : 'px-[22px] pb-[24px] bg-[#ffffff]'
                        } w-full`}
                    >
                        {detailTitleBlock?.boolValue && !isKOL && (
                            <div className='w-full bg-[#fff] py-[14px] border-b-[1px] border-[#E5E5E5] mb-[16px] break-all'>
                                <div
                                    className='text-[#031E6C] text-[13px] line-clamp-1'
                                    dangerouslySetInnerHTML={{
                                        __html: contentCategoryText,
                                    }}
                                />
                                <div
                                    className='text-[18px] pb-[8px] max-w-[320px] md:max-w-[410px] w-[90%]'
                                    style={{ wordBreak: 'break-word' }}
                                    dangerouslySetInnerHTML={{
                                        __html: pageTitle?.value || '',
                                    }}
                                />
                                <div className='text-[13px] text-[#6C6C6C]'>
                                    {updateDatetime?.dateValue && updateDatetime.dateValue > 0
                                        ? format(
                                              new Date(updateDatetime.dateValue),
                                              'dd/MM/yyyy HH:mm'
                                          )
                                        : startDatetime?.dateValue
                                        ? format(
                                              new Date(startDatetime.dateValue),
                                              'dd/MM/yyyy HH:mm'
                                          )
                                        : ''}
                                </div>
                                {shareIcon?.boolValue && (
                                    <img
                                        className='w-[20px] absolute top-[15px] right-[15px] z-10'
                                        src={withBasePath('/images/share_blue.svg')}
                                        alt=''
                                        loading='lazy'
                                    />
                                )}
                            </div>
                        )}
                        <div className='pointer-events-none'>
                            {bettingStrategyStore.GetBetpickTitleList() && (
                                <div className='flex justify-between items-center py-[12.5px]'>
                                    <div className='font-medium text-[18px]'>
                                        {t('kol:betlinesOverview')}
                                    </div>
                                    {isShowBettingBtn && (
                                        <AllBettingStrategyBTN contentBlock={contentBlockData} />
                                    )}
                                </div>
                            )}

                            <Suspense fallback={<SpinLoading />}>
                                <DynamicComponent
                                    componentDataList={componentDataList}
                                    currentPath={comCurrentPath}
                                    contentBlock={contentBlockData}
                                    badgesIconData={props.badgesIconData.Item?.data || []}
                                    updateShowChanges={(v: boolean) => {
                                        setshowOddsChangesCom(v);
                                    }}
                                    AllUpData={AllUpData}
                                />
                            </Suspense>

                            {showOddsChanges && showOddsChangesCom && (
                                <div className='pt-2'>
                                    <OddsChanges />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {showOddsTips && (
                    <div className='mb-[35px] pl-[8px]'>
                        <DeatilRemark remark={t('common:Remark')} enabled={showOddsTips || isKOL} />
                    </div>
                )}
            </div>
            <Open3in1App
                currentPath={comCurrentPath}
                contentBlock={contentBlock}
                getOverLayHeight={(v) => setPBNum(v)}
            />
        </>
    );
};

export const getServerSideProps: GetServerSideProps = async (
    ctx
): Promise<GetServerSidePropsResult<Omit<AppArticlePageProp, 'sectionData'> | ErrorPageProp>> => {
    const { section, detail } = ctx.params || {};
    const locale = ctx.locale || AppLanguage.en_us;
    const anotherLocale = locale === AppLanguage.zh_hk ? AppLanguage.en_us : AppLanguage.zh_hk;

    // const sliderPath = toSiteCorePath(section);
    const detailPath = toSiteCorePath(`${section}/${detail}`);

    const [
        badgesIconData,
        contentBlockData,
        detailTemplateName,
        anotherDetailTemplateName,
        CategoryItem,
    ] = await Promise.all([
        withOps('share-article-badgesIconData', () =>
            sitecoreClient.BadgesIconQuery({ lang: locale })
        ),
        withOps('share-article-contentBlockData', () =>
            sitecoreClient.DetailMainContentBlockQuery({ path: detailPath, lang: locale })
        ),
        withOps('share-article-detailTemplateName', () =>
            sitecoreClient.generalPageQuery({ path: detailPath, lang: locale })
        ),
        withOps('share-article-anotherDetailTemplateName', () =>
            sitecoreClient.generalPageQuery({ path: detailPath, lang: anotherLocale })
        ),
        withOps('share-article-CategoryItem', () =>
            sitecoreClient.CategoriesQuery({ lang: 'zh-CN' })
        ),
    ]);

    const componentList = detailTemplateName.generalPage?.row || [];
    const anotherComponentList = anotherDetailTemplateName.generalPage?.row || [];

    const fetchComponentData = async (list: any[], lang: string) => {
        return await Promise.all(
            list.map(async (item) => {
                const queryFn =
                    sitecoreClient[`${item.template.name}Query` as keyof typeof sitecoreClient];
                return queryFn
                    ? await withOps(
                          `article-${lang === anotherLocale ? 'another-' : ''}${
                              item.template.name
                          }`,
                          () => (queryFn as any)({ path: item.path, lang })
                      )
                    : null;
            })
        );
    };

    const componentDataList = await fetchComponentData(componentList, locale);
    const anotherComponentDataList = await fetchComponentData(anotherComponentList, anotherLocale);

    const hasComponentData = componentDataList.length > 0;
    const hasAnotherComponentData = anotherComponentDataList.length > 0;

    const item = contentBlockData.Item as { blockType?: { value?: string } };

    if (
        (!hasComponentData && !hasAnotherComponentData) ||
        !isContentBlockPublished(contentBlockData.Item) ||
        isContentBlockExpired(contentBlockData.Item) ||
        item.blockType?.value === 'Video'
    ) {
        return {
            props: {
                errorPageType: ErrorPageType.noSharePage,
                contentBlockData: contentBlockData.Item,
                ...(await serverSideTranslations(locale, ['common', 'share'])),
            },
        };
    }

    const canAccess = await predicateContentBlock(
        contentBlockData.Item,
        ctx.query?.seg,
        ctx.query?.ac
    );
    if (!canAccess) {
        return {
            props: {
                errorPageType: ErrorPageType.noSharePage,
                contentBlockData: contentBlockData.Item,
                ...(await serverSideTranslations(locale, ['common', 'share'])),
            },
        };
    }

    const isSurvey = componentDataList.some(
        (item: any) => item.content?.template?.name === 'QualtricsSurveyComponent'
    );
    if (isSurvey) {
        return {
            props: {
                errorPageType: ErrorPageType.noSharePage,
                contentBlockData: contentBlockData.Item,
                ...(await serverSideTranslations(locale, ['common', 'share'])),
            },
        };
    }

    const metaItem = await withOps('share-article-metaItem', () =>
        sitecoreClient.metaQuery({ lang: ctx.locale || '' })
    );

    const AllUpData = await withOps('share-article-AllUpData', () =>
        sitecoreClient.AllupBetlineQuery({
            lang: ctx.locale || AppLanguage.en_us,
        })
    );
    /** 简体中文category data */
    const categoryData = CategoryItem?.Item?.data ?? [];

    return {
        props: {
            currentPath: section || '',
            comCurrentPath: `${section}/${detail}`,
            componentDataList,
            contentBlockData: contentBlockData.Item,
            language: locale,
            pageType: 'detailArticle',
            badgesIconData,
            metaItem,
            mediaDomain,
            AllUpData: AllUpData.allupBetlines?.data,
            categoryData,
            ...(await serverSideTranslations(locale, ['common', 'home', 'kol', 'share'])),
        },
    };
};

export default memo(Detail);
